<template>
  <div class="text-2xl font-bold text-left">
    <slot></slot>
  </div>
</template>
